import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConnectionService } from 'src/app/connection.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-account-details',
  templateUrl: './account-details.component.html',
  styleUrls: ['./account-details.component.css']
})
export class AccountDetailsComponent implements OnInit {
  address: string;
  transactionList: any;
  trans: number = 1
  accountAddress: any;
  searchobj: any = {
    searchAddress: ''
  }
  tokenTransfer: number = 1
  searchListDetails: any;
  balance: any
  changeDetactor: any;
  transferList: any;
  accountInfo: any = {};
  voteCount: any;
  srvoteCount: any;

  constructor(private conn: ConnectionService, private activateRoute: ActivatedRoute,
    private alert: ToastrService, private router: Router, private spinner: NgxSpinnerService) {
  }

  ngOnInit() {
    this.address = localStorage.getItem('Address');
    this.accountAddress = this.activateRoute.snapshot.params['address']
    this.transactionHistory(this.accountAddress)
    this.getBalance();
    this.Energy_bandwidth();
    this.getcurrentVotes();
    this.Srdetails(this.accountAddress)
    this.transferHistory(this.accountAddress)
    this.conn.setRoute.subscribe((res: any) => {
      if (res) {
        window.location.reload()
        this.transactionHistory(this.accountAddress)
      }
    })
  }

  changeStatus(address?: any) {
    this.accountAddress = address
    this.transactionHistory(address)
  }

  changeTransfer(address?: any) {
    this.accountAddress = address
    this.transferHistory(address)
  }

  getcurrentVotes() {
    this.conn.postUrl('vote/currentVoteByAddress', { address: this.accountAddress }).subscribe((res: any) => {
      if (res.data ? res.data[0].total : res.data) {
        this.voteCount = res.data[0].total;
      }
      else {
        this.voteCount = 0;
      }
    })
  }

  Srdetails(repaddress?: any) {
    this.conn.postUrl('superRep/getAllWitnessbyaddress', { address: repaddress }).subscribe(async (res: any) => {
      this.srvoteCount = res.data != null ? res.data.voteCount : '0';
    });
  }


  getBalance() {
    this.conn.postUrl('users/userBalance', { address: this.accountAddress }).subscribe((res: any) => {
      this.balance = res.data.userBalance;
    })
  }

  Energy_bandwidth() {
    this.conn.postUrl('user_contract/account_Energy_bandwidth', { address: this.accountAddress }).subscribe((res: any) => {
      this.accountInfo = res.data;
    })
  }


  transactionHistory(address) {
    this.conn.postUrl('users/txnGetByAddress', { fromAddress: address, toAddress: address }).subscribe((res: any) => {
      this.spinner.show()
      if (res.success == true) {
        this.spinner.hide()
        this.transactionList = res.data
      }
    })
  }

  transferHistory(address) {
    this.conn.postUrl('users/addressContractTransaction', { address: address }).subscribe((res: any) => {
      this.transferList = res.data
    })
  }

  copyText(val: string) {
    let selBox = document.createElement('input');
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.alert.success('Copied to the clipboard');
  }

}
